module.exports = __webpack_public_path__ + "img/left_5.cdd92fe7.jpg";